<template>
  <div>
    <div 
      class="clickable head"
      @click="onPlayerSelected(playerKey)">{{credits.players[playerKey].name}} ({{teamName}})</div>

    <div class="boxes compact width30 big-numbers" v-if="isMiniView">
      <div><div class="highlight">{{credits.players[playerKey].fantasyCredit.credits | locale}}</div><label>Credit</label></div>
    </div>
    <template v-else>
      <div class="boxes compact width30 big-numbers">
        <div><div class="highlight">{{credits.players[playerKey].fantasyCredit.credits | locale}}</div><label>Credit</label></div>
        <div><div>{{credits.players[playerKey].fantasyCredit.rank | locale}}</div><label>Rank</label></div>
        <div><div>{{credits.players[playerKey].fantasyCredit.score | locale}}</div><label>Score</label></div>
      </div>
      <div class="sub-head">Recent Points</div>
      <div class="boxes compact">
        <div class="max-240">
          <span
          class="silent"
          v-for="(prevPoints, index) in credits.players[playerKey].fantasyCredit.prev_points" :key="index"
          ><router-link
            class="clean colored tag"
            :to="{name:'match', params:{key:prevPoints.match_key}}">{{prevPoints.points | locale}}</router-link>.
          </span>
        </div>
      </div>
    </template>


    <div
      class="boxes compact width30"
      v-if="appState.fantasy.showEdit"
    >
      <fantasy-add-to-team-button
        :playerKey="playerKey"
        :credit="credits.players[playerKey].fantasyCredit.credits"
      ></fantasy-add-to-team-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    playerKey: String,
    teamName: String,
    credits: Object,
    isMiniView: Boolean,
  },
  methods: {
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    }
  }
}
</script>

